import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { PurchaseComponentsModule } from './purchase-components.module';
import { routes } from './purchase.route';
import { BASE_PURCHASE_SERVICE } from './services/base-purchase.service';
import { PurchaseService } from './services/purchase.service';

@NgModule({
  imports: [UIRouterModule.forChild(routes), PurchaseComponentsModule],
  exports: [PurchaseComponentsModule],
  providers: [{ provide: BASE_PURCHASE_SERVICE, useExisting: PurchaseService }],
})
export class PurchaseModule {}
